import { MatchesSearch } from "../entities/userUnjabbed";
import { MatchSearchParams } from "../entities/getMatchSearchParams";
import { MatchRepository } from "../repositories/MatchRepository";

export interface GetMatchSearchParams {
	params: MatchSearchParams;
	clientSearchVersion?: number;
	clientExcludedUserIds?: string[];
	clientMinimumDistanceExclusive?: number;
	clientMaximumDistanceInclusive?: number;
	clientMaximumMatches?: number;
	clientExpandFartherIfEmpty?: boolean;
}

export class GetMatchSearch {
	constructor(private repository: MatchRepository) {}
	execute(params: GetMatchSearchParams): Promise<MatchesSearch> {
		return this.repository.getMatchSearch(params.params);
	}
}
